module.exports = __webpack_public_path__ + "img/map.ddb5fea1.svg";